//export const API_URL = 'http://localhost:8001/api/v1';
export const API_URL = 'https://classified.ebslab.in/api/v1';
